import { AddIcon, Button, TagField, Text } from '@viapeople/components'
import { pluralize } from '../../utils/formatters'

interface Reviewer {
	externalId: string
	firstName: string
	lastName: string
}

interface Group {
	id: string
	name: string
	minReviewers: number
	maxReviewers: number
	reviewers: Reviewer[]
}

interface ReviewersGroupProps {
	group: Group
	error?: string
	onRemoveReviewer: (value: { id: string; label: string }[], groupId: string) => void
	onAddClick: (groupId: string) => void
	allowEditing: boolean
}

export const ReviewersGroup = ({ group, error, onRemoveReviewer, onAddClick, allowEditing }: ReviewersGroupProps) => {
	const hint = `${group.minReviewers > 0 ? `Min: ${group.minReviewers} ${pluralize(group.minReviewers, 'reviewer', 'reviewers')}. ` : ''} ${group.maxReviewers > 0 ? `Max: ${group.maxReviewers} ${pluralize(group.maxReviewers, 'reviewer', 'reviewers')}. ` : ''}`

	return (
		<div className='flex px-6 pb-6'>
			<TagField
				label={`${group.name} (${group.reviewers.length})`}
				placeholder=''
				className='min-h-13'
				value={group.reviewers.map((reviewer) => ({
					id: reviewer.externalId,
					label: `${reviewer.firstName} ${reviewer.lastName}`,
				}))}
				disabled={!allowEditing}
				variant={error ? 'error' : 'default'}
				hint={
					<>
						{error && (
							<Text variant='hint' weight='regular' className='text-error-600 inline'>
								{error}
							</Text>
						)}
						<Text variant='hint' weight='regular' className='inline text-neutral-600'>
							{hint}
						</Text>
					</>
				}
				onChange={(value) => onRemoveReviewer(value, group.id)}
			/>
			{allowEditing && (
				<Button
					variant='secondary'
					icon={AddIcon}
					iconPosition='right'
					className='ml-2 mt-7'
					onClick={() => onAddClick(group.id)}>
					Add
				</Button>
			)}
		</div>
	)
}
